import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const status = [
    { label: 'Draft', color: 'default' },
    { label: 'Pending approval', color: 'warning' },
    { label: 'Approved', color: 'success' },
    { label: 'Canceled', color: 'default' },
    { label: 'Invalid', color: 'error' },
    { label: 'Paid', color: 'warning' },
    { label: 'Partially paid', color: 'warning' },
];

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

export default function MultipleSelectChip({ filter, setFilter }) {
    const theme = useTheme();


    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setFilter(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    console.log(filter.length)

    return (
        <>
            <label>Status</label>
            <Select
                multiple
                sx={{ width: "100%" }}
                value={filter}
                onChange={handleChange}
                input={<OutlinedInput id="select-multiple-chip" />}
                renderValue={(selected) => (
                    <Box sx={{ display: 'inline', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => (
                            <Chip key={value} label={value} />
                        ))}
                    </Box>
                )}
                MenuProps={MenuProps}>
                {status.map((status) => (
                    <MenuItem
                        key={status.label}
                        value={status.label}
                        style={getStyles(status.label, filter, theme)}>
                        {status.label}
                    </MenuItem>
                ))}
            </Select>
        </>
    );
}